import React from 'react';
import { Separator } from './ui/separator';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_URL = "https://wa.me/525538164204?text=Hola%2C%20necesito%20soporte%20de%20NOVOPAY";

const legalLinks = [
  { title: "Términos y Condiciones", href: "#terminos" },
  { title: "Aviso de Privacidad Simplificado", href: "#privacidad-simple" },
  { title: "Aviso de Privacidad Integral", href: "#privacidad-integral" },
  { title: "Política de Divulgación de Riesgos", href: "#riesgos", important: true },
  { title: "Unidad Especializada/CONDUSEF", href: "#condusef" },
  { title: "Buró de Entidades Financieras", href: "#buro" },
  { title: "Contratos de Adhesión", href: "#contratos" }
];

export const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img 
                src="/logo-novopay.png"
                alt="NOVOPAY Logo" 
                className="h-12 w-auto"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMjAwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8dGV4dCB4PSIxMCIgeT0iNDAiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIyNCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IiNFQUIzMDgiPk5PVk9QQVk8L3RleHQ+Cjwvc3ZnPgo=';
                }}
              />
            </div>
            <p className="text-slate-300 mb-6 leading-relaxed">
              La solución integral para empresas mexicanas. 
              Seguridad, eficiencia y confianza en cada transacción.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <p className="text-sm font-semibold text-slate-400 uppercase tracking-wide">
                Contacto
              </p>
              <div className="space-y-2 text-slate-300">
                <p>✉️ contacto@novopay.mx</p>
                <p>📍 Ciudad de México, México</p>
              </div>
            </div>

            {/* WhatsApp Support */}
            <div className="space-y-3">
              <p className="text-sm font-semibold text-slate-400 uppercase tracking-wide">
                Soporte
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-support-link"
                className="inline-flex items-center space-x-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-5 py-3 rounded-lg font-semibold transition-colors duration-200"
              >
                <MessageCircle className="h-5 w-5" />
                <div className="text-left">
                  <div className="text-xs opacity-90">Soporte por WhatsApp</div>
                  <div className="text-sm">+52 55 3816 4204</div>
                </div>
              </a>
            </div>
          </div>
          
          {/* Legal Links */}
          <div className="lg:col-span-3">
            <h3 className="text-lg font-bold mb-6">Información Legal</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {legalLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className={`text-slate-300 hover:text-white transition-colors duration-200 py-2 border-l-2 pl-4 ${
                    link.important 
                      ? 'border-yellow-400 text-yellow-400 hover:text-yellow-300 font-semibold' 
                      : 'border-transparent hover:border-slate-600'
                  }`}
                >
                  {link.title}
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <Separator className="my-12 bg-slate-700" />
        
        {/* Bottom Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
          <div className="text-center lg:text-left">
            <p className="text-slate-400 text-sm leading-relaxed max-w-2xl">
              NOVOPAY es una solución autorizada y supervisada por las autoridades financieras mexicanas. 
              Cumplimos estrictamente con todas las disposiciones legales, normas de seguridad y regulaciones 
              financieras aplicables en México para garantizar la protección de nuestros usuarios.
            </p>
          </div>
          
          <div className="text-slate-400 text-sm text-center lg:text-right">
            <p>&copy; 2026 NOVOPAY. Todos los derechos reservados.</p>
            <p className="mt-1">Tecnología que impulsa la libertad financiera</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
